import { styled } from '@mui/system';
import Header from './components/Header'
import Navbar from './components/Navbar'
import About from './components/About'
import Experience from './components/Experience'
import Education from './components/Education';
import Services from './components/Services'
import Portfolio from './components/Portfolio'
import Contact from './components/Contact'
import Footer from './components/Footer'



const Container = styled('div')({
  backgroundColor: 'var(--color-bg)',
  color: 'var(--color-white)',
  backgroundImage: 'repeating-linear-gradient(90deg, #1f1f38, #1f1f38 3px, #2c2c6c50, #2c2c6c50 3px, #2c2c6c50 6px)',
  display: 'flex',
  flexDirection: 'column',
  gap: '10vh'
})


function App() {
  return (
    <div className="App">
      <Navbar />
      <Container >
        <Header />
        <About />
        <Experience />
        <Education />
        <Services />
        <Portfolio />
        <Contact />
        <Footer />
      </Container>
    </div>

  );
}

export default App;
